import { gql } from "@apollo/client";
import { BasicQueryInfoInput } from "../../FeedDataCalls/GQLCalls/getFeedComponentsCall";

export const CONTROLLER_LOG_AICO = gql`
query ControllerLogsAico($domain: String!, $input: BasicQueryInfoInput!, $filter: LogFilterInput) {
  controller {
    controllerLogsAico(domain: $domain, input: $input, filter: $filter) {
      lan_controller_log_id
      fk_lan_controllers
      timestamp
      level
      type
      message
      fk_terminals
      fk_animals
      controller_id
      controller_name
      lan_controller_cpu_id
      device_id
      device_name
      device_cpu_id
      port
      terminal_type
      location_name
      location_id
    }
  }
}
`
export interface BasicQueryInfoFilter {
  levels?: number;
  types?: number;
}

export interface LanControllerLogAicoParameters {
    domain: string;
    input: BasicQueryInfoInput;
    filter?: BasicQueryInfoFilter;     
}

export interface LanControllerLogAicoArgs {
      lan_controller_log_id: number;
      fk_lan_controllers: number;
      timestamp: number;
      level: number;
      type: number;
      message: string;
      fk_terminals: number;
      fk_animals: number;
      controller_id: number;
      controller_name: string;
      lan_controller_cpu_id: string;
      device_id: number;
      device_name: string;
      device_cpu_id: string;
      port: number;
      terminal_type: number;
      location_name: string;
      location_id: number;
}

export interface LanControllerLogAicoResponse {
    controller: {
        controllerLogsAico: LanControllerLogAicoArgs[]
    } 
}